import React, { ReactNode } from "react";
import styles from "./FormFields.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";
import { useTranslation } from "react-i18next";

type Props = {
  label: string;
  value: string;
  type?: "text" | "long-text" | "password";
  description?: ReactNode | string;
  required?: boolean;
  error?: string;
  options?: {
    descPosition?: "top" | "bottom";
    styles?: {
      input?: object;
    };
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  dataTestId?: string;
};

const FormInputText = ({
  label,
  value,
  type = "text",
  description,
  error,
  options,
  required = false,
  onChange,
  dataTestId,
}: Props) => {
  const { t } = useTranslation();
  const descPosition = options?.descPosition || "bottom";
  const optionStyles = options?.styles || {};

  return (
    <div className={styles.form}>
      <div className={styles.formLabelContent}>
        <span className={styles.formLabel} data-testid={dataTestId ? `${dataTestId}-label` : ""}>
          {label}
        </span>
        {required && (
          <span className={styles.formLabelRequired}>
            <img src={getImageUrl("images/icons/asterisk.svg")} width={20} height={20} />
            {t("SettingsModalFormInputText.必須")}
          </span>
        )}
      </div>
      {description && descPosition === "top" && <p className={styles.formDescription}>{description}</p>}
      {type === "long-text" ? (
        <textarea onChange={onChange} className={styles.formTextarea} value={value} />
      ) : (
        <input
          type={type}
          className={styles.formInput}
          style={optionStyles?.input ? { ...optionStyles.input } : {}}
          onChange={onChange}
          value={value}
        />
      )}
      {description && descPosition === "bottom" && <p className={styles.formDescription}>{description}</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

export default FormInputText;
